// extracted by mini-css-extract-plugin
export var container = "_5m-1";
export var editor = "_5m-2";
export var resizable = "_5m-3";
export var wrapper = "_5m-0";